module.exports = __webpack_public_path__ + "static/us-pop3-c0744a78e64239e23d985bc70ee0ef9a.png";